import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import CreateTenant from "../CreateTenantModal/CreateTenantModal";
import { IoEyeOutline } from "react-icons/io5";
import usePermission from "../../utils/usePermission";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import { MdEdit } from "react-icons/md";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import { CiSearch } from "react-icons/ci";
import useTenantListing from "../../customHooks/TeanantListing/useTenantListing";
import { te } from "date-fns/locale";
import { addMinutes, format, parseISO, subMinutes } from "date-fns";
import placeholder from "../../assets/images/placeholder.png";
import { useNavigate } from "react-router";
import { FaEye } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { Loader as LoaderIcon } from "react-feather";

const TenantListing = ({ type }) => {
  const navigate = useNavigate();
  const {
    allTenants,
    currentPage,
    totalCount,
    searchTerm,
    tenantsPerPage,
    excludeInactive,
    activeCount,
    inactiveCount,
    isModalOpen,
    loader,
    handlePageClick,
    handleSearch,
    handlePageSizeChange,
    handleExcludeInactiveChange,
    openModal,
    closeModal,
    exportToExcel,
    setCurrentPage,
    setSearchTerm,
    fetchTenants,
    searchEmail,
    setsearchEmail,
    openPurge,
    setOpenPurge,
    selectedOption,
    setSelectedOption,
    customDate,
    setCustomDate,
    showConfirm,
    handleDelete,
    setShowConfirm,
    handlePurge,
    getCutoffDate,
    purgeLoader,
  } = useTenantListing({ type });
  const canRead = usePermission("TENANT_READ");
  const canWrite = usePermission("TENANT_CREATE");
  const canUpdate = usePermission("TENANT_UPDATE");
  const canPurge = usePermission("UNINSTALLED_MERCHANTS_PURGE");
  const canDeleteRead = usePermission("UNINSTALLED_MERCHANTS_READ");
  const readPermission = type === "activeMerchants" ? canRead : canDeleteRead;

  return (
    <div>
      {readPermission ? (
        <div className="container">
          <div className="mainHeader">
            <h1 className="text-lg font-semibold">
              {type === "activeMerchants"
                ? "Merchant Listing"
                : "Deleted Merchants"}
            </h1>
            <div className="flex gap-4">
              {/* <button
                className="add-tenant-button"
                onClick={exportToExcel}
                disabled={!allTenants.length}
              >
                Export
              </button> */}
              {type === "activeMerchants" ? (
                <>
                  {canWrite && (
                    <button
                      className="bg-blue-600 text-white px-4 py-2 rounded-md shadow hover:bg-blue-700"
                      onClick={() => {
                        navigate("/tenant/create");
                      }}
                    >
                      + OnBoard Merchant
                    </button>
                  )}
                </>
              ) : (
                <>
                  {canPurge && (
                    <button
                      className="bg-blue-600 text-white px-4 py-2 rounded-md shadow hover:bg-blue-700"
                      onClick={() => {
                        setOpenPurge(true);
                      }}
                    >
                      Purge Tenants
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="mainHeader">
            <div className="flex gap-4">
              {/* <div className="form-group">
                    <select
                      className="border border-gray-300 p-2 rounded-md"
                      value={tenantsPerPage}
                      onChange={handlePageSizeChange}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                    </select>
                  </div> */}
              <div className="form-group">
                <label htmlFor="featureCategoryId">Search By Brand Name</label>
                <div className="search-container">
                  <input
                    type="text"
                    placeholder="Search By Brand Name..."
                    className="search-input"
                    value={searchTerm}
                    onChange={handleSearch}
                  />

                  <CiSearch className="search-icon" />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="featureCategoryId">Search By Email</label>
                <div className="search-container">
                  <input
                    type="text"
                    placeholder="Search By Email..."
                    className="search-input"
                    value={searchEmail}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.startsWith(" ")) return; // block leading space
                      setsearchEmail(value); // ✅ always update state
                    }}
                    onBlur={() => {
                      if (
                        searchEmail &&
                        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(searchEmail)
                      ) {
                        // show error or reset
                       
                      }
                    }}
                  />

                  <CiSearch className="search-icon" />
                </div>
              </div>
            </div>
          </div>
          {!loader ? (
            <div className="mainContainer">
              {/* <div className="flex justify-between items-center mb-4">
                <div className="text-lg font-medium">
                  <span className="text-gray-700">{allTenants.length}</span>{" "}
                  Total Tenants |{" "}
                  <span className="text-green-600">{activeCount}</span> Active
                  Tenants |{" "}
                  <span className="text-red-600">{inactiveCount}</span> Inactive
                  Tenants
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    className="form-checkbox h-5 w-5 text-blue-600 mr-2"
                    checked={excludeInactive}
                    onChange={handleExcludeInactiveChange}
                  />
                  <span className="text-gray-600">
                    Exclude Inactive Customers
                  </span>
                </div>
              </div> */}

              <div className="table-container">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Brand Logo</th>
                      <th>Brand Name</th>
                      <th>Merchant Email</th>
                      <th>Store Name</th>
                      <th>Status</th>
                      <th>Merchant Onboarded On</th>

                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allTenants.length > 0 ? (
                      allTenants.map((tenant, index) => {
                        const utcCreaedAt = tenant.MerchantOnboardedOn
                          ? subMinutes(
                              parseISO(tenant.MerchantOnboardedOn),
                              330
                            )
                          : "";
                        const utcExpiry = tenant.PlanEndDate
                          ? subMinutes(parseISO(tenant.PlanEndDate), 330)
                          : null;

                        const utcstartDate = tenant.PlanStartDate
                          ? subMinutes(parseISO(tenant.PlanStartDate), 330)
                          : null;
                        const formattedTime = format(
                          utcCreaedAt,
                          "MMMM d, yyyy"
                        );

                        const formattedExpiry = format(
                          utcExpiry,
                          "MMMM d, yyyy"
                        );
                        const formattedStart = format(
                          utcstartDate,
                          "MMMM d, yyyy"
                        );
                        return (
                          <tr key={tenant.iTenantId}>
                            <td className="px-4 py-2 text-sm font-medium text-gray-900">
                              {tenant.sBrandLogo ? (
                                <img
                                  src={tenant.sBrandLogo}
                                  alt="store type"
                                  className="w-16 h-10 object-contain rounded"
                                />
                              ) : (
                                <img
                                  src={placeholder}
                                  alt="store type"
                                  className="w-16 h-10 object-contain rounded"
                                />
                              )}
                            </td>
                            <td>{tenant.sBrandName}</td>
                            <td>{tenant.sTenantEmail}</td>
                            <td>{tenant.storeTypeName}</td>
                            <td>{tenant.sStatus}</td>
                            <td>
                              {tenant.MerchantOnboardedOn ? formattedTime : ""}
                            </td>

                            <td>
                              <div className="actionBtns flex gap-4">
                                <button
                                  className="editButtom"
                                  onClick={() => {
                                    navigate(`/tenant/${tenant.iTenantId}`);
                                  }}
                                >
                                  <FaEye />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-gray-600">
                          No Tenants Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {totalCount !== 0 && (
                <div className="mt-6 flex justify-between items-center">
                  <span className="text-gray-600">
                    Showing {(currentPage - 1) * tenantsPerPage + 1} to{" "}
                    {Math.min(currentPage * tenantsPerPage, totalCount)} of{" "}
                    {totalCount} entries
                  </span>
                  {totalCount > tenantsPerPage && (
                    <Pagination
                      activePage={currentPage}
                      itemsCountPerPage={tenantsPerPage}
                      totalItemsCount={totalCount}
                      pageRangeDisplayed={5}
                      onChange={handlePageClick}
                      nextPageText={">"}
                      prevPageText={"<"}
                      firstPageText={"<<"}
                      lastPageText={">>"}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <div>
              {" "}
              <FullPageLoading />
            </div>
          )}

          <CreateTenant
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            setCurrentPage={setCurrentPage}
            setSearchTerm={setSearchTerm}
            fetchTenants={fetchTenants}
            tenantsPerPage={tenantsPerPage}
            excludeInactive={excludeInactive}
          />
        </div>
      ) : (
        <UnAuthorized />
      )}
      <Modal
        show={openPurge}
        onHide={() => {
          setOpenPurge(false);
          setCustomDate("");
          setSelectedOption("");
        }}
        centered
      >
        <Modal.Header closeButton>
          <h1 className="font-bold text-xl">Purge Tenants</h1>
        </Modal.Header>
        <Modal.Body>
          {showConfirm ? (
            <p className="text-red-500 mt-2">
              Are you sure you want to purge merchants before{" "}
              {selectedOption === "custom"
                ? customDate
                : getCutoffDate(parseInt(selectedOption))}
              ?
            </p>
          ) : (
            <div className="form-group">
              <label className="block">Select Date Range</label>
              <select
                name="dateRange"
                value={selectedOption}
                onChange={(e) => setSelectedOption(e.target.value)}
              >
                <option value="">Select</option>
                <option value="30">Before 30 Days</option>
                <option value="60">Before 60 days</option>
                <option value="180">Before 180 days</option>
                <option value="custom">Custom Date</option>
              </select>

              {selectedOption === "custom" && (
                <div className="form-group">
                  <label className="block">Select Date</label>
                  <input
                    type="date"
                    name="customDate"
                    value={customDate}
                    onChange={(e) => setCustomDate(e.target.value)}
                  />
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-between gap-6">
            {!showConfirm ? (
              <button
                className="save-button"
                onClick={handleDelete}
                disabled={
                  !selectedOption ||
                  (selectedOption === "custom" && !customDate)
                }
              >
                Proceed
              </button>
            ) : (
              <div className="flex gap-4 flex-col">
                <div className="flex justify-end gap-4">
                  {purgeLoader ? (
                    <button
                      className="save-button"
                      style={{ width: "100px" }}
                      disabled={purgeLoader}
                    >
                      <LoaderIcon size={20} className="indicator" />
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="save-button"
                      disabled={purgeLoader}
                      onClick={() => {
                        handlePurge();
                      }}
                    >
                      Yes, Purge
                    </button>
                  )}
                  <button
                    className="cancel-button"
                    onClick={() => setShowConfirm(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TenantListing;
